"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingIssueStatus = void 0;
var ListingIssueStatus;
(function (ListingIssueStatus) {
    ListingIssueStatus["OPEN"] = "open";
    ListingIssueStatus["CLOSED"] = "closed";
})(ListingIssueStatus = exports.ListingIssueStatus || (exports.ListingIssueStatus = {}));
const ListingIssuesApiFactory = (http) => ({
    getListingsByProperty(propertyId) {
        return http.get(`listings-v2/property/${propertyId}/listings`);
    }
});
exports.default = ListingIssuesApiFactory;
//# sourceMappingURL=listingIssues.js.map